import React from 'react';
import { translations } from '../data/translations';
import './Explanation.css';

const Explanation = ({ language, onNavigateHome }) => {
  const content = translations[language];

  return (
    <main className="explanation-container" role="main" tabIndex={-1}>
      {onNavigateHome && (
        <button
          type="button"
          className="icon-button page-home-button"
          onClick={onNavigateHome}
          aria-label={content.homeNavLabel}
          title={content.homeNavLabel}
        >
          &#8962;
        </button>
      )}

      <h1>{content.explanationTitle}</h1>

      <section className="explanation-section">
        <h2>{content.whatIsTitle}</h2>
        <p>{content.whatIsContent}</p>
        <p>{content.detailedIntroduction}</p>
      </section>

      <section className="explanation-section">
        <h2>{content.coreMusclesTitle}</h2>
        <ul>
          {content.coreMusclesPoints.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </section>

      <section className="explanation-section">
        <h2>{content.stepGuideTitle}</h2>
        <ol>
          {content.stepGuideSteps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </section>

      <section className="explanation-section">
        <h2>{content.benefitsTitle}</h2>
        <p>{content.benefitsContent}</p>
      </section>

      <section className="explanation-section" aria-live="polite">
        <h2>{content.whenToAvoidTitle}</h2>
        <ul>
          {content.whenToAvoidPoints.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      </section>

      <section className="explanation-section">
        <h2>{content.accessibilityTitle}</h2>
        <p>{content.accessibilityContent}</p>
      </section>

      <section className="explanation-section">
        <h2>{content.supportTitle}</h2>
        <p>{content.supportContent}</p>
        <p className="creator-note">
          {content.creatorNoteIntro}{' '}
          <a href="https://simonertel.net" target="_blank" rel="noreferrer">
            simonertel.net
          </a>
          . {content.creatorNoteSupport}{' '}
          <a href="https://simon.gallery/shop" target="_blank" rel="noreferrer">
            simon.gallery/shop
          </a>
          .
        </p>
      </section>
    </main>
  );
};

export default Explanation;
